// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_components_home_home_module_ts":"10a86e8f9f397f02","default-src_app_modules_components_authentication_authentication_module_ts":"7f98b1c9813fb523","src_app_modules_components_policy_policy_module_ts":"86dd6799d9d6b737"}[chunkId] + ".js";
};